import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../../../components/Form/Field'

import { selectedPartnershipCurrency } from '../../../../../../../../modules/selectors/partnerships'

import {
  BID_CAP,
  BUDGET,
  DIGITAL_ALLOCATION_IMPRESSIONS,
  DIGITAL_ALLOCATION_TYPE,
  DIGITAL_ALLOCATION_TYPE_BUDGET
} from '../../../../fields'

import useDrawerFormStyles from '../../../../../../../../styles/common/drawerForms'

function DigitalRightEditAllocationSection({ formik, isAdvancedPartnership }) {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()
  const { currency_symbol: currencySymbol } = useSelector(selectedPartnershipCurrency)

  const { values } = formik

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{isAdvancedPartnership ? t('Budget') : t('Allocation')}</h3>
      {values[DIGITAL_ALLOCATION_TYPE] === DIGITAL_ALLOCATION_TYPE_BUDGET ? (
        <>
          <p>
            {isAdvancedPartnership
              ? t('A maximum budget that can be spread across the different ad platforms.')
              : t('The partner will be able to spend up to this amount (including any margin)')}
          </p>
          <Field
            placeholder="Budget"
            type="number"
            formik={formik}
            name={BUDGET}
            symbol={currencySymbol}
            enableReinitialize
            inputMode="numeric"
          />
        </>
      ) : (
        <>
          <p>
            {t(
              'The partner will not be able to choose an optimisation goal and the campaigns will deliver until the impression goal has been met.'
            )}
          </p>
          <Field
            placeholder="Impressions"
            type="number"
            formik={formik}
            name={DIGITAL_ALLOCATION_IMPRESSIONS}
            enableReinitialize
            inputMode="numeric"
          />
          <p>
            {t(
              'Impressions based allocations will deliver until the impression goal has been reached. Please enter a bid cap for each thousand impressions (CPM) to limit the media cost.'
            )}
          </p>
          <Field
            placeholder="Bid cap"
            symbol={currencySymbol}
            type="number"
            formik={formik}
            name={BID_CAP}
            enableReinitialize
            inputMode="numeric"
          />
        </>
      )}
    </section>
  )
}

export default DigitalRightEditAllocationSection
